import { Button, IconButton } from "@/src/components/buttons";
import { openDialog } from "@/src/components/dialogs";
import moment from "moment";
import { useState } from "react";
import Calendar from "react-calendar";
import {
  FaChevronLeft,
  FaChevronRight,
  FaRegCalendarAlt,
} from "react-icons/fa";

export function MyDatePicker({
  value,
  onChange,
}: {
  value: string | null;
  onChange: (newValue: string | null) => void;
}) {
  const [reload, setReload] = useState<number>(0);
  const [startDate, setStartDate] = useState<Date | null | undefined>(
    moment(value || undefined).toDate()
  );
  const [localValue, setLocalValue] = useState<Date | null | undefined>(
    moment(value || undefined).toDate()
  );
  const buttons = [
    { label: "Aujourdhui", days: 0, months: 0 },
    { label: "Une semaine", days: 7, months: 0 },
    { label: "Un mois", days: 0, months: 1 },
    { label: "Trois mois", days: 0, months: 3 },
    { label: "Six mois", days: 0, months: 6 },
    { label: "Un an", days: 0, months: 12 },
  ];

  function onLocalChange(newValue: Date | null | undefined) {
    setLocalValue(newValue);
    setStartDate(newValue);
    onChange(newValue ? moment(newValue).format("YYYY-MM-DD HH:mm:ss") : null);
  }

  return (
    <div className="c1-auto gap10 bs br p5">
      <div key={`myDatePicker${reload}`} className="fade">
        <Calendar
          onChange={(newValue) => {
            onLocalChange(newValue as any);
          }}
          value={localValue}
          onActiveStartDateChange={(newValue) => {
            setStartDate(newValue.activeStartDate);
          }}
          activeStartDate={startDate || new Date()}
        />
      </div>
      <div>
        <div className="c1 gap10 p5">
          {buttons.map((button, index) => {
            let newDate = moment()
              .add(button.days, "days")
              .add(button.months, "months")
              .toDate();
            return (
              <Button
                key={index}
                type={
                  moment(newDate).format("YYYY-MM-DD") ===
                  moment(localValue).format("YYYY-MM-DD")
                    ? "primary"
                    : "tertiary"
                }
                onClick={() => {
                  onLocalChange(newDate);
                  setReload(reload + 1);
                }}
              >
                {button.label}
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export async function openDatePickerDialog({
  value,
  onChange,
}: {
  value: string | null | undefined;
  onChange: (newValue: string | null | undefined) => void;
}) {
  let localValue = value;
  await openDialog({
    id: "datePickerDialog",
    title: "Choisir une date",
    content: (
      <MyDatePicker
        value={null}
        onChange={(newValue) => {
          localValue = newValue;
        }}
      ></MyDatePicker>
    ),
    onConfirm: async () => {
      onChange(localValue);
    },
  });
}

export function DayPicker({
  value,
  increment,
  onChange,
}: {
  value: string | null | undefined;
  increment?: number;
  onChange: (newValue: string) => void;
}) {
  const [localValue, setLocalValue] = useState(value);

  increment ||= 1;
  function onLocalChange(newValue: string) {
    if (!newValue || newValue == "Invalid date")
      newValue = moment().format("YYYY-MM-DD");

    setLocalValue(newValue);
    onChange(newValue);
  }

  return (
    <div
      className={`noCalendarIcon daypicker ${
        localValue == moment().format("YYYY-MM-DD") ? "today" : ""
      }`}
    >
      <IconButton
        onClick={() => {
          let newValue = moment(localValue)
            .subtract(increment, "day")
            .format("YYYY-MM-DD");
          onLocalChange(newValue);
        }}
      >
        <FaChevronLeft />
      </IconButton>
      <input
        type="date"
        value={localValue || ""}
        onChange={(e) => {
          if (!e.target.value || e.target.value == "Invalid date")
            return onLocalChange(moment().format("YYYY-MM-DD"));
          onLocalChange(e.target.value);
        }}
      />
      <IconButton
        isSecondary={true}
        onClick={() => {
          openDatePickerDialog({
            value: localValue,
            onChange: (newValue) => {
              onLocalChange(
                moment(newValue).format("YYYY-MM-DD") ||
                  moment().format("YYYY-MM-DD")
              );
            },
          });
        }}
      >
        <FaRegCalendarAlt color="black" size={16} />
      </IconButton>
      <IconButton
        onClick={() => {
          let newValue = moment(localValue)
            .add(increment, "day")
            .format("YYYY-MM-DD");
          onLocalChange(newValue);
        }}
      >
        <FaChevronRight />
      </IconButton>
    </div>
  );
}
